<template>
  <header id="nav-wrapper">
    <div class="header flex flex-column">
      <UIHeaderPrimary />
    </div>
  </header>
</template>

<style scoped lang="scss">
  .header {
    position: fixed;
    z-index: 1000;
    width: 100%;
  }
</style>
